// extracted by mini-css-extract-plugin
module.exports = {"container":"Section7_container__aD2Mh","content":"Section7_content__ndmaw","headline":"Section7_headline__JKDgJ","subHeadline":"Section7_subHeadline__no6sy"};